<template>
  <CCard v-if="hasPerm('edge.orders.total')" class="payment-details-card">
    <CCardHeader>
      <h5 class="my-2">
        <CIcon name="cilCreditCard" class="mr-2"/>
        <translate translate-context="edge-orders.payment">Payment Details</translate>
      </h5>
    </CCardHeader>
    <CCardBody class="px-0">
      <CContainer fluid>
        <dl class="row mb-0 list-striped">
          <dt class="col-sm-5 col-xl-4">
            <translate translate-context="edge-orders.payment">Subtotal</translate>
          </dt>
          <dd class="col-sm-7 col-xl-8">
            {{ order.subtotal_amount | currency(order.currency) }}
          </dd>

          <dt class="col-sm-5 col-xl-4">
            <translate translate-context="edge-orders.payment">Discount</translate>
          </dt>
          <dd class="col-sm-7 col-xl-8">
            {{ order.discount_amount | currency(order.currency) }}
          </dd>
          <dt class="col-sm-5 col-xl-4">
            <translate translate-context="edge-orders.payment">Total Amount</translate>
          </dt>
          <dd class="col-sm-7 col-xl-8">
            <strong class="text-primary">{{ order.total_amount | currency(order.currency) }}</strong>
          </dd>

          <dt class="col-sm-5 col-xl-4" v-if="hasPerm('edge.orders.payment_platform')">
            <translate translate-context="edge-orders.payment">Payment Platform</translate>
          </dt>
          <dd class="col-sm-7 col-xl-8" v-if="hasPerm('edge.orders.payment_platform')">
            <CIcon v-if="getPlatformIcon(order.payment_platform)" :name="getPlatformIcon(order.payment_platform)" class="mr-2"/>
            {{ getPlatformLabel(order.payment_platform) }}
          </dd>

          <dt class="col-sm-5 col-xl-4" v-if="order.payment_method">
            <translate translate-context="edge-orders.payment">Payment Method</translate>
          </dt>
          <dd class="col-sm-7 col-xl-8" v-if="order.payment_method">
            {{ order.payment_method }}
          </dd>
        </dl>
      </CContainer>
    </CCardBody>
  </CCard>
</template>

<script>
import Filters from '@/domain/core/utils/filters'
import { getPaymentPlatformLabel, getPaymentPlatformIcon } from '@/domain/core/constant/paymentPlatform'

export default {
  name: 'PaymentDetails',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  methods: {
    getPlatformLabel(platform) {
      if (!platform) return '-'
      return getPaymentPlatformLabel(platform)
    },
    getPlatformIcon(platform) {
      if (!platform) return null
      return getPaymentPlatformIcon(platform)
    }
  },
  filters: {
    currency: Filters.currency
  }
}
</script>

<style scoped>
.payment-details-card {
  margin-top: 2rem;
  border-top: 3px solid #e8e8e8;
}

.list-striped dt,
.list-striped dd {
  padding: 0.75rem 1rem;
}

.list-striped dt:nth-of-type(odd),
.list-striped dd:nth-of-type(odd) {
  background-color: #f8f9fa;
}
</style>